
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { GroupUserItemProps } from ".";
import { loading, create } from "store/group-user";
import { AppMessage } from "components";

interface ApiGroupUserCreateInputProps extends Omit<GroupUserItemProps, "id"> {
}

type ApiGroupUserCreateOutputProps = OutputBaseProps<{ item: GroupUserItemProps; }, ApiGroupUserCreateInputProps>

export const apiGroupUserCreate = async (data: ApiGroupUserCreateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.post<ApiGroupUserCreateOutputProps>("/api/group/create", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(create({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};